<template>
    <div class="paperpile_left_sidebar">
        <div class="paperpile_filer_list_wrp">
            <!-- <h3 class="paperpile_filer_heading">My Library</h3> -->
            <ul class="paperpile_filer_list">
                <li>
                    <router-link :to="{ name: 'paperPiles' }"><i class="fa fa-book" aria-hidden="true"></i> My
                        Papers</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'favouritePaperList' }"><i class="fa fa-star" aria-hidden="true"></i>
                        Favourites</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'awerackSharedPaper' }"><i class="fa fa-share-alt" aria-hidden="true"></i>
                        Shared Papers</router-link>
                </li>
                <li>
                    <router-link :to="{ name: 'awerackResearchGroup' }"><i class="fa fa-search" aria-hidden="true"></i>
                        Research Groups</router-link>
                </li>
            </ul>
            <div class="bucket_option_wrp">
                <h3 class="paperpile_filer_heading bucket_option_heading">My Shelf
                    <i class="fa fa-plus-circle" aria-hidden="true" @click="openNewBcuketFolderPopup"></i>
                    <i class="fa fa-chevron-circle-up allfoldercollapsed" aria-hidden="true"></i>
                </h3>
                <bucket-tree-view :tree-data="bucketListResults"></bucket-tree-view>
            </div>
            <h3 class="paperpile_filer_heading">
                <router-link :to="{ name: 'trashPaperList' }"><i class="fa fa-trash mr-1" aria-hidden="true"></i>
                    Trash</router-link>
            </h3>
            <!-- <h3 class="paperpile_filer_heading">
      <router-link :to="{name:'paperPilesPreferences'}">Preferences</router-link>
    </h3> -->
        </div>
        <!-- Remove Bucket Popup Code Here -->
        <remove-bucket v-bind:removeBucketID="removeBucketId" v-if="removeBucketPopupState"></remove-bucket>
        <!-- Remove Bucket Popup Code Here -->
        <!-- Rename Bucket Popup Code Here -->
        <rename-bucket v-if="updateBucketPopupState" v-bind:updateBucketDETAIL="updateBucketDetail"></rename-bucket>
        <!-- Rename Bucket Popup Code Here -->
        <new-bucket-folder v-if="newBucketFolderPopupState"></new-bucket-folder>
        <new-sub-bucket-folder v-if="newSubBucketFolderPopupState" v-bind:newSubBucketFolderID="newSubBucketFolderId">
        </new-sub-bucket-folder>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import bucketTreeView from './tree-view-bucket.vue';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import newBucketFolder from './new-bucket-folder';
import newSubBucketFolder from './new-subbucket-folder';
import removeBucket from './delete-bucket';
import renameBucketname from './rename-bucket';

export default {
    name: 'paperpile-left-sidebar',
    components: {
        'new-bucket-folder': newBucketFolder,
        'new-sub-bucket-folder': newSubBucketFolder,
        'bucket-tree-view': bucketTreeView,
        'rename-bucket': renameBucketname,
        'remove-bucket': removeBucket,
    },
    props: [],
    data() {
        return {
            newBucketFolderPopupState: false,
            bucketListDetails: {},
            bucketListResults: [],
            removeBucketPopupState: false,
            removeBucketId: '',
            updateBucketPopupState: false,
            updateBucketDetail: '',
            newSubBucketFolderPopupState: false,
            newSubBucketFolderId: '',
        }
    },
    computed: {
        ...mapGetters([
            'getBucketListOfAwerackGetters',
        ]),
        getBucketListDetailsFun() {
            this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
            return
        },
        setIntialStateOfBucket() {
            if (this.bucketListDetails != undefined) {
                this.bucketListResults = this.bucketListDetails.results
            }
        }
    },
    mounted() {
        this.getBucketListDetailsFun
        this.setIntialStateOfBucket
        bus.$on('newBucketFolderPopupStateBus', (data) => {
            this.newBucketFolderPopupState = data;
        });
        bus.$on('newSubBucketFolderPopupStateBus', (data) => {
            this.newSubBucketFolderPopupState = data;
        });
        bus.$on('removeBucketPopupStateBus', (data) => {
            this.removeBucketPopupState = data;
        });
        bus.$on('updateBucketPopupStateBus', (data) => {
            this.updateBucketPopupState = data;
        });
        $('.allfoldercollapsed').click(function () {
            if ($('.sub_folder_dd ').hasClass('show_sub_bucket')) {
                $('.sub_folder_dd ').removeClass('show_sub_bucket')
                $(this).removeClass('open')
            } else {
                $('.sub_folder_dd ').addClass('show_sub_bucket')
                $(this).addClass('open')
            }
        })
    },
    methods: {
        bucketDetailRouting(bucketID) {
            if (bucketID != this.$route.params.bucketId) {
                this.$router.push({ name: 'bucketDetails', params: { bucketId: bucketID } })
                this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: bucketID }).then((res) => {
                }).catch((err) => {
                })
            }
        },
        getBucketListAgainMethod() {
            this.$store.dispatch('getBucketListOfAwerackFun').then((res) => {
            }).catch((err) => { })
        },
        openNewBcuketFolderPopup() {
            this.newBucketFolderPopupState = true
            document.body.classList.add('body_right_scroll_remove')
        },
        removeBucketPopupOpenMethod(itemId) {
            this.removeBucketId = itemId
            this.removeBucketPopupState = true
            document.body.classList.add('body_right_scroll_remove')
        },
        openRenameBucketPopup(data) {
            this.updateBucketDetail = data
            this.updateBucketPopupState = true
            document.body.classList.add('body_right_scroll_remove')
        },
        addNewSubBucketFolderMethod(id) {
            this.newSubBucketFolderPopupState = true
            this.newSubBucketFolderId = id
            document.body.classList.add('body_right_scroll_remove')
        },
    },
    watch: {
        getBucketListDetailsFun() {
            return this.$store.getters.getResearchGroupForAwerackGetters
        },
        setIntialStateOfBucket() {
            if (this.bucketListDetails != undefined) {
                this.bucketListResults = this.bucketListDetails.results
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.paperpile_left_sidebar {
    // background: rgba(9, 9, 9, 0.95);
    // -webkit-box-shadow: 3px 1px 10px rgba(138, 145, 153, 0.05);
    // box-shadow: 3px 1px 10px rgba(138, 145, 153, 0.08);
    // border-radius: 5px;
    // border: 1px solid rgba(23, 23, 23, 0.8);
    padding: 20px 15px 15px;
    height: 100%;
    width: 260px;
    min-height: calc(100dvh - 80px);
    position: relative;
    // z-index: 1;
    &:before {
        content: "";
        position: absolute;
        inset: 0;
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        // background: rgba(28, 22, 108, 0.25);
        background: rgba(9, 9, 9, 0.95);
        border: 1px solid rgba(255, 255, 255, 0.03);
        z-index: -1;
        border-radius: 5px;
    }

    @media only screen and (max-width:769px) {
        min-height: inherit;
    }

    .paperpile_filer_heading {
        font-size: 21px;
        color: #ffffff;
        text-transform: uppercase;
        margin: 0px;
        position: relative;

        a {
            color: #ffe9e9;
            text-decoration: none;
            display: block;
            padding: 10px 15px;
            border-radius: 12px;

            &.router-link-exact-active {
                    background: rgba(111, 111, 111, 0.2);
                    color: #ffd700;
            }

            &:hover {
                    background: rgba(111, 111, 111, 0.2);
                    color: #ffd700;
            }
        }

        &.bucket_option_heading {
            .fa-plus-circle {
                position: absolute;
                right: 28px;
                line-height: 1;
                top: 2px;
                cursor: pointer;
                font-size: 22px;

                &:hover {
                    color: #ffd700;
                }
            }

            .allfoldercollapsed {
                backface-visibility: hidden;
                transform: rotate(0deg);
                -webkit-transform: rotate(0deg);
                position: absolute;
                right: 0px;
                top: 2px;
                cursor: pointer;
                font-size: 22px;
                transition: transform ease 0.5s;
                transform-origin: center center;
                -webkit-transform-origin: center center;
                line-height: 1;
                -webkit-transition: transform ease 0.5s;

                &:hover {
                    color: #ffd700;
                }

                &.open {
                    color: #ffd700;
                    transform: rotate(180deg);
                    -webkit-transform: rotate(180deg);
                }
            }
        }
    }

    .paperpile_filer_list {
        margin-bottom: 30px;

        li {
            a {
                color: #ffe9e9;
                text-decoration: none;
                display: block;
                padding: 12px 15px;
                border-radius: 12px;

                &.router-link-active {
                    background: rgba(111, 111, 111, 0.2);
                    color: #ffd700;
                }

                &:hover {
                    background: rgba(111, 111, 111, 0.2);
                    color: #ffd700;
                }

                .fa {
                    margin-right: 5px;
                }
            }

            margin-top:5px;
            color:#d6d6d6;
            font-size:17px;
            line-height:1;

            &:first-child {
                margin-top: 0px;
            }
        }

        border-bottom:1px solid rgba(110, 110, 110, 0.1);
        padding-bottom:30px;
    }

    .bucket_option_wrp {
        margin-bottom: 30px;
        border-bottom: 1px solid rgba(110, 110, 110, 0.1);
        padding-bottom: 30px;

        .bucket_folder_list {
            margin: 0;
            padding-left: 15px;

            .bucket_folder_list_item {
                color: #d6d6d6;
                font-size: 16px;
                margin-top: 15px;
                position: relative;
                cursor: pointer;

                .bucket_folder_list_name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .bucket_option_dd {
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: none;

                    .fa-chevron-down {
                        font-size: 14px;

                        &:hover {
                            color: #ffd700;
                        }
                    }

                    &.show .fa-chevron-down {
                        color: #ffd700;
                    }

                    &.show {
                        display: block;
                    }

                    .bucket_option_list {
                        padding: 5px 10px;
                        background: rgba(0, 0, 0, 0.92);
                        box-shadow: 0px 0px 3px rgba(255, 255, 255, 0.2);

                        .bucket_option_item {
                            color: #d6d6d6;
                            font-size: 16px;
                            margin-top: 10px;

                            &:hover {
                                color: #ffd700;
                            }

                            &:first-child {
                                margin-top: 0px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>